import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import PrevNext from './PrevNext';
const HeaderWithPagination = ({ labelText, labelInfo, settings = {
    showHeaderTitle: true,
    showHeaderActions: true,
}, isMobileView, hasNext, hasPrev, goNext, goPrev, }) => (_jsxs(Box, { sx: (t) => ({
        width: '100%',
        borderBottomWidth: '2px',
        borderBottomStyle: 'solid',
        borderBottomColor: t.portal?.global?.secondary?.color,
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 'auto',
        marginBottom: 'auto',
        py: 1,
        pt: { md: 1, xs: '0px' },
        alignItems: { xs: 'center' },
    }), children: [(labelText || labelInfo) && (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'row' }, children: [settings.showHeaderTitle && labelText
                    && (_jsx(Typography, { variant: "subtitle1", fontWeight: 600, className: "lessonTitle", sx: { mr: 1, lineHeight: { xs: 1.4 } }, children: labelText })), labelInfo && (_jsx(Typography, { variant: "subtitle1", fontWeight: 600, className: "lessonTitle", sx: { lineHeight: { xs: 1.4 } }, children: labelInfo }))] })), settings.showHeaderActions && (_jsx(PrevNext, { goNext: goNext, goPrev: goPrev, hasNext: hasNext, hasPrev: hasPrev, isMobileView: isMobileView }))] }));
HeaderWithPagination.defaultProps = {
    labelText: '',
    labelInfo: '',
    settings: {
        showHeaderTitle: true,
        showHeaderActions: true,
    },
};
export default HeaderWithPagination;
//# sourceMappingURL=HeaderWithPrevNext.js.map